import React from "react";
import {useState} from "react";
import style from "./style.module.css";
import BaseApi from "../../../services/Api";
import {toast} from "react-toastify";
import Swal from "sweetalert2";
import {Spinner} from "react-bootstrap";
import { useEffect } from "react";

export default function Information() {
  let idInformation = 1;

  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);

  const [instagram, setInstagram] = React.useState("");
  const [opening_hours, setOpeningHours] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [addres, setAddres] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [facebook, setFacebook] = React.useState("");
  const [linkedin, setLinkedin] = React.useState("");

  const buildFormData = () =>{
    const formData = new FormData();
    if(instagram!=undefined){

      formData.append("instagram", instagram)
    }
    if(opening_hours!=undefined){

      formData.append("opening_hours", opening_hours)
    }
    if(description!=undefined){

      formData.append("description", description)
    }
    if(addres!=undefined){

      formData.append("addres", addres)
    }
    if(email!=undefined){

      formData.append("email", email)
    }
    if(phone!=undefined){

      formData.append("phone", phone)
    }
    if(facebook!=undefined){

      formData.append("facebook", facebook)
    }
    if(linkedin!=undefined){

      formData.append("linkedin", linkedin)
    }


    if(idInformation){
      formData.append('_method', 'PUT')
    } 
    return formData
  }

  const formData = buildFormData();

  const onSave = () => {
    Swal.fire({
      title: 'Certeza que deseja salvar?',
      text: "Você não conseguirá reverter isso!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Salvar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitData();
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Operação cancelada!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    })
  }

  const submitData = () => {
    setSaving(true);
    BaseApi.post(`/informacoes/${idInformation}`, formData).then(res => {
      setSaving(false);
      toast.success('Informação salva com sucesso!');
      
    }).then(() => {
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Dados salvos com sucesso!',
        showConfirmButton: false,
        timer: 1500
      }).then(() => window.location.reload(false))
    }).catch(err => {
      console.log(err);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: `${err?.response?.data?.message}`,
        showConfirmButton: false,
        timer: 1500
      })
      setSaving(false);
    })
  }


  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/informacoes`).then(res => {
      let data = res.data;
      setOpeningHours(data.opening_hours);
      setDescription(data.description);
      setAddres(data.addres);
      setEmail(data.email);
      setPhone(data.phone);
      setInstagram(data.instagram);
      setFacebook(data.facebook);
      setLinkedin(data.linkedin);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este lead ou não foi encontrado.', 'error');
    })
  }

  useEffect(() => {
      requestData();
  }, [])

  return(
    <>
    <div className="d-flex flex-column">
      <div className="d-flex flex-column flex-nd-row pb-4">
        <div className={style.information}>
          <h1>Informação</h1>
        </div>
      </div>
      <div className="d-flex align-items-center justify-content-center">
        {isLoading && (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </div>
        <>
        {!isLoading && (


          <div className="row">           
            <div className="form-group mb-3">
              <label  htmlFor="email">Endereço de Email </label> 
              <div>
                <input 
                  name="text" 
                  id="email" 
                  className="form-control"
                  placeholder="Insira o endereço de email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="form-group mb-3">
              <label  htmlFor="">Número de Telefone </label> 
              <input
                type="text"
                className="form-control"
                id="phone"
                placeholder="Insira o número de telefone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>
            <div className="form-group mb-3">
              <label  htmlFor="opening_hours">Horário de Funcionamento </label> 
              <div>
                <input 
                  name="text" 
                  id="opening_hours" 
                  placeholder="Insira o horário de funcionamento"
                  className="form-control"
                  value={opening_hours}
                  onChange={(e) => setOpeningHours(e.target.value)}
                />
              </div>
            </div>

            <div className="form-group mb-3">
              <label  htmlFor="addres">Endereço </label> 
              <div>
                <input 
                  name="text" 
                  id="addres" 
                  className="form-control"
                  placeholder="Insira o endereço"
                  value={addres}
                  onChange={(e) => setAddres(e.target.value)}
                />
            </div>
            

            <div className="form-group mb-3">
              <label  htmlFor="description">Descrição </label> 
              <div>
                <textarea 
                  name="text" 
                  id="description" 
                  cols="30" 
                  rows="5"
                  className="form-control"
                  placeholder="Insira a descrição"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </div>
            </div>
            <div className="form-group mb-3">
              <label htmlFor="instagram">Instagram </label> 
              <input
                type="url"
                className="form-control"
                id="instagram"
                placeholder="Insira o perfil do Instagram"
                value={instagram}
                onChange={(e) => setInstagram(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="facebook">Facebook </label> 
              <input
                type="url"
                className="form-control"
                id="facebook"
                placeholder="Insira o perfil do facebook"
                value={facebook}
                onChange={(e) => setFacebook(e.target.value)}
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="linkedin">Linkedin </label>
              <input
                type="url"
                className="form-control"
                id="linkedin"
                placeholder="Insira um link para o linkedin"
                value={linkedin}
                onChange={(e) => setLinkedin(e.target.value)}
              />
            </div>

          </div>


            <button
              loading={isSaving}
              onClick={onSave}
              className="btn btn-success text-white"
            >
            Salvar
            </button>    
          </div>
        )} 
        </>
    </div>
    </>
  )
}